module.exports = __webpack_public_path__ + "img/logo-text.ca6f3a67.svg";